module.exports = __webpack_public_path__ + "assets/icon-csat-heart-round-bg.b0ca14c2.svg";